import Vue from 'vue'
import Router from 'vue-router'
const ReportDetails = resolve => require(['../components/ReportDetails.vue'], resolve); 
const sendReport= resolve => require(['../components/sendReport.vue'], resolve);
const report= resolve => require(['../components/report.vue'], resolve);
const savewx=resolve => require(['../components/savewx.vue'], resolve)

Vue.use(Router)
const router= new Router({
  mode:'history',
  base:'/',
  routes: [{
       path: '/',
       redirect: '/test/reportDetails'
      },
     // 报告详情页
  {
    path: '/test/reportDetails', //?code=
    component: ReportDetails 
  },
  {
    path:'/test/reportPlan',
    component:sendReport
  },
  {
    path:'/report',
    component:report
  },
  {
    path: '/save/wx',
    component:savewx,
  }
  ]
})

router.afterEach(to => {
  if (gtag) {
    gtag('config', 'UA-139122490-4', { 'page_path': to.fullPath })
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js